import { tableColumnsType } from '../components/edit-table/editable-table';
import linkExceptions from '../services/Utils/linkExceptions';

export interface CompanyConsumable {
  id: string;
  smsConsumableCode?: string | null;
  companyConsumableCode?: string | null;
  companyConsumableDesc?: string | null;
  equipment?: string | null;
  type?: string | null;
  warehouseIdentification?: string | null;
  warehousePosition?: string | null;
  drawing?: string | null;
  remarks?: string | null;
}
const itemDocumentFinderMasterColumns = (): tableColumnsType[] => {
  return [
    {
      Header: 'Consumable Code',
      accessor: 'consumableCodes',
      editType: 'inputField',
      options: [],
      linkType: true,
      linkExceptions: linkExceptions,
    },
    {
      Header: 'Consumable Name',
      accessor: 'consumableName',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Company Code',
      accessor: 'companyConsumableCode',
      editType: 'inputField',
      options: [],
      linkType: true,
      linkExceptions: linkExceptions,
    },
    {
      Header: 'Company Description',
      accessor: 'companyConsumableDesc',
      editType: 'inputField',
      options: [],
    },
  ];
};

export default itemDocumentFinderMasterColumns;
